// @flow
import styled, { injectGlobal, css } from 'styled-components'
import range from 'lodash/range'
import { Link } from 'react-router-dom'
import { media } from './style-utils'
// $FlowFixMe
import CircularStd from 'src/assets/fonts/CircularStd-Book.otf'
// $FlowFixMe
import CircularMedium from 'src/assets/fonts/CircularStd-Medium.otf'
// $FlowFixMe
import CircularBold from 'src/assets/fonts/CircularStd-Bold.otf'
// $FlowFixMe
import TheCollectiveBecomeEOT from 'src/assets/fonts/TheCollectiveBecome-Medium.eot'
// $FlowFixMe
import TheCollectiveBecomeTTF from 'src/assets/fonts/TheCollectiveBecome-Medium.ttf'
// $FlowFixMe
import TheCollectiveBecomeWOFF from 'src/assets/fonts/TheCollectiveBecome-Medium.woff'
// $FlowFixMe
import TheCollectiveBecomeWOFF2 from 'src/assets/fonts/TheCollectiveBecome-Medium.woff2'
// $FlowFixMe
import RelativeFauxTTF from 'src/assets/fonts/Relative-Faux-Web.ttf'
// $FlowFixMe
import RelativeFauxEOT from 'src/assets/fonts/Relative-Faux-Web.eot'
// $FlowFixMe
import RelativeFauxWOFF from 'src/assets/fonts/Relative-Faux-Web.woff'
// $FlowFixMe
import RelativeFauxWOFF2 from 'src/assets/fonts/Relative-Faux-Web.woff2'
// $FlowFixMe
import RelativeBookTTF from 'src/assets/fonts/Relative-Book-Web.ttf'
// $FlowFixMe
import RelativeBookEOT from 'src/assets/fonts/Relative-Book-Web.eot'
// $FlowFixMe
import RelativeBookWOFF from 'src/assets/fonts/Relative-Book-Web.woff'
// $FlowFixMe
import RelativeBookWOFF2 from 'src/assets/fonts/Relative-Book-Web.woff2'
// $FlowFixMe
import RelativeBoldTTF from 'src/assets/fonts/Relative-Bold-Web.ttf'
// $FlowFixMe
import RelativeBoldEOT from 'src/assets/fonts/Relative-Bold-Web.eot'
// $FlowFixMe
import RelativeBoldWOFF from 'src/assets/fonts/Relative-Bold-Web.woff'
// $FlowFixMe
import RelativeBoldWOFF2 from 'src/assets/fonts/Relative-Bold-Web.woff2'
// $FlowFixMe
import RelativeMediumTTF from 'src/assets/fonts/Relative-Medium-Web.ttf'
// $FlowFixMe
import RelativeMediumEOT from 'src/assets/fonts/Relative-Medium-Web.eot'
// $FlowFixMe
import RelativeMediumWOFF from 'src/assets/fonts/Relative-Medium-Web.woff'
// $FlowFixMe
import RelativeMediumWOFF2 from 'src/assets/fonts/Relative-Medium-Web.woff2'
// $FlowFixMe
import YellowSvg from 'src/assets/yellow_pattern.svg'
// $FlowFixMe
import GreenSvg from 'src/assets/green_pattern.svg'
// $FlowFixMe
import NewLogoSvg from 'src/assets/new_logo.svg'
// $FlowFixMe
import BorderSvg from 'src/assets/border.svg'

export const theme = {
  white: '#fff',
  black: '#000',
  primary: '#29dc8d',
  primaryHint: 'rgba(47, 231, 150, 0.8)',
  primaryText: '#6e7b8c',
  secondary: '#d2d9e2',
  secondaryText: '#a2aebf',
  danger: '#ff4a4a',
  info: '#ddebf8',
  interest: '#f6ebd2',
  light: '#f4f4f4',
  lightText: '#9dabba',
  dark: '#9dabba',
  darkText: '#082622',
  darker: '#4a5665',
  superlight: '#f0f3f5',
  transparent: 'transparent',
  borderRadius: '6px'
}

range(36, 77).forEach(i => {
  injectGlobal`
  li[data-flag-key="flag_no_${i}"]{
    display:none;
  }
`
})

range(201, 203).forEach(i => {
  injectGlobal`
  li[data-flag-key="flag_no_${i}"]{
    display:none;
  }
`
})

range(143, 157).forEach(i => {
  injectGlobal`
  li[data-flag-key="flag_no_${i}"]{
    display:none;
  }
`
})

range(214, 216).forEach(i => {
  injectGlobal`
  li[data-flag-key="flag_no_${i}"]{
    display:none;
  }
`
})

range(497, 510).forEach(i => {
  injectGlobal`
  li[data-flag-key="flag_no_${i}"]{
    display:none;
  }
`
})

range(100, 103).forEach(i => {
  injectGlobal`
  li[data-flag-key="flag_no_${i}"]{
    display:none;
  }
`
})

range(256, 497).forEach(i => {
  injectGlobal`
  li[data-flag-key="flag_no_${i}"]{
    display:none;
  }
`
})

injectGlobal`
 @font-face {
    font-family: "TheCollectiveBecome";
    src: url('${TheCollectiveBecomeEOT}?#iefix') format('embedded-opentype'), 
         url('${TheCollectiveBecomeWOFF}') format('woff'), 
         url('${TheCollectiveBecomeWOFF2}') format('woff2'), 
         url('${TheCollectiveBecomeTTF}')  format('truetype');
 }
 
 @font-face {
    font-family: "RelativeBook";
     src: url('${RelativeBookEOT}?#iefix') format('embedded-opentype'), 
         url('${RelativeBookWOFF}') format('woff'), 
         url('${RelativeBookWOFF2}') format('woff2'), 
         url('${RelativeBookTTF}')  format('truetype');
  }

 @font-face {
    font-family: "RelativeBold";
     src: url('${RelativeBoldEOT}?#iefix') format('embedded-opentype'), 
         url('${RelativeBoldWOFF}') format('woff'), 
         url('${RelativeBoldWOFF2}') format('woff2'), 
         url('${RelativeBoldTTF}')  format('truetype');
  }
  
 @font-face {
    font-family: "RelativeMedium";
     src: url('${RelativeMediumEOT}?#iefix') format('embedded-opentype'), 
         url('${RelativeMediumWOFF}') format('woff'), 
         url('${RelativeMediumWOFF2}') format('woff2'), 
         url('${RelativeMediumTTF}')  format('truetype');
  }

  @font-face {
    font-family: "RelativeFaux";
    src: url('${RelativeFauxEOT}?#iefix') format('embedded-opentype'), 
         url('${RelativeFauxWOFF}') format('woff'), 
         url('${RelativeFauxWOFF2}') format('woff2'), 
         url('${RelativeFauxTTF}')  format('truetype');
  }
  
  
  @font-face {
    font-family: "CircularStd";
    src: url('${CircularStd}') format('opentype');
  }

  @font-face {
    font-family: "CircularStd Medium";
    src: url('${CircularMedium}') format('opentype');
  }

  @font-face {
    font-family: "CircularStd Bold";
    src: url('${CircularBold}') format('opentype');
  }

  * {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    padding: 0;
    margin: 0;
    font-family: "RelativeBook", "Helvetica", "Arial", sans-serif;
  }

  h1 {
    font-family: "RelativeBook", "Helvetica", "Arial", sans-serif;
    font-weight: normal;
    font-size: 24px;
    margin: 0;
  }

  h2 {
    font-family: "RelativeBook", "Helvetica", "Arial", sans-serif;
    font-weight: normal;
    font-size: 20px;
  }

  h3 {
    font-family: "RelativeBook", "Helvetica", "Arial", sans-serif;
    font-weight: normal;
    font-size: 18px;
  }

  button {
    border-style: none;
    text-decoration: none;
    outline: none;
    cursor: pointer;
    user-select: none;
  }

  input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
      -moz-appearance: textfield;
  }
  
  .dial-code {
    display: none
  }
  
  div.flag.undefined:before {
    content: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4gICAgPHBhdGggc3Ryb2tlPSIjOURBQkJBIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTYuMjA0IDMuNDc5Yy42OTQuNTEzIDEuMjU3IDEuMTY0IDEuNzY3IDIuMDIuNDQ2Ljc0NyAxLjQzNyAyLjgyNy41MjkgNC0xLjAyNyAxLjMyOS00IDEuNzc2LTQgMyAwIC45MjEgMS4zMDQgMS45NzMgMiAzIDEuMDQ3IDEuNTQ2LjU3MSAzLjA0NSAwIDQtLjI5Ni40OTctLjc2OS45Mi0xLjI5MyAxLjIzNU0yMS4xNjggNS43MjdDMTkuMDA5IDYuNzYyIDE2LjA0MiA3LjQ2MSAxNS41IDcuNWMtMS4wNDUuMDc1LTEuMi0uNzg0LTItMi0uNi0uOTEyLTItMi4wNTMtMi0zIDAtLjM3LjAzNi0uNjcyLjEzMS0uOTY2Ii8+ICAgIDxwYXRoIHN0cm9rZT0iIzlEQUJCQSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xMi41IDIzLjVjNi4wNzUgMCAxMS00LjkyNSAxMS0xMXMtNC45MjUtMTEtMTEtMTEtMTEgNC45MjUtMTEgMTEgNC45MjUgMTEgMTEgMTF6Ii8+ICAgIDxwYXRoIHN0cm9rZT0iIzlEQUJCQSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xOS41MTQgMTMuNDAzYy4wNDIgMy4wODQtMy45NzIgNi45My02LjAxNCA2LjA5Ny0xLjc5LS43My0uNTI3LTIuMTM4LS45ODYtNi4wOTctLjE5MS0xLjY0NiAxLjU2Ny0zIDMuNS0zczMuNDc4IDEuMzQ0IDMuNSAzeiIvPjwvc3ZnPg==);
    line-height: 28px;
    display: inline;
    left: -9px;
    top: -7px;
    font-size: 20px;
    position: relative;
  }
  
  div.react-tel-input .selected-flag .arrow{
    position: absolute;
  }
  
  @media print{    
    .no-print, .no-print *
    {
        display: none !important;
    }
  }
  
`

export const NewLogo = styled.div`
  width: 60px;
  height: 60px;
  position: absolute;
  top: 23px;
  z-index: 100;
  ${media.tablet`
    left: 250px;
  `}
  ${media.desktop`
    left: 130px;
  `}
  ${media.giant`
    left: 250px;
  `}
  background-image: url('${NewLogoSvg}');
`

export const YellowPattern = styled.div`
  position: fixed;
  z-index: 0;
  top: 0;
  left: 0;
  ${media.phone`
    width: 100%;
    height: 980px;
    background-position: 63% 122%;
  `}
   ${media.tablet`
    width: 100%;
    height: 986px;
    background-position: 50% 112%;
  `}
   ${media.desktop`
    width: 100%;
    height: 986px;
    background-position: 50% 112%;
  `}
  ${media.giant`
    width: 100%;
    height: 986px;
    background-position: 94% 112%;
  `}  
  background-repeat: no-repeat;
  background-image: url('${YellowSvg}');
`

export const GreenPattern = styled.div`
  position: fixed;
  z-index: 0;
  top: 660px;
  right: 0;
  width: 346px;
  height: 577px;
  background-repeat: no-repeat;
  background-image: url('${GreenSvg}');
`

export const Button = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 60px;
  color: ${props => props.theme.white};
  background-color: ${props => (props.makeDisabled ? '#d2d9e2' : '#000000')};
  font-family: 'TheCollectiveBecome', 'RelativeFaux', 'Helvetica', 'Arial', sans-serif;
  font-size: 16px;
  ${props =>
    !props.makeDisabled &&
    `&:hover {
    background-color: #a0ce99;
  }
  &:active {
    background-color: #c1e2bc;
  }`} ${props =>
    props.narrow &&
    css`
      width: 70%;
    `};
`
export const Title = styled.h1`
  text-align: left;
  color: ${props => props.theme.darkText};
  font-family: 'TheCollectiveBecome', 'RelativeFaux', 'Helvetica', 'Arial', sans-serif;
  margin-bottom: 20px;
  font-size: 30px;
  font-weight: 500;

  ${media.tablet`
    margin-top: 20px;
    ${props =>
      props.noMargin &&
      css`
        margin: 0;
      `};
  `};

  ${props =>
    props.large &&
    css`
      font-size: 40px;
    `};

  ${props =>
    props.medium &&
    css`
      font-size: 32px;
      margin-top: 20px;
      margin-bottom: 20px;

      ${media.tablet`
        margin-top: 80px;
      `};
    `};

  ${props =>
    props.lessMargin &&
    css`
      margin-bottom: 20px;
    `};

  ${props =>
    props.noMargin &&
    css`
      margin: 0;
    `};

  ${props =>
    props.isPadded &&
    css`
      padding: 0 40px;
    `};
`
export const Heading = styled.h2`
  color: ${props => props.theme.darkText};
`
export const SubHeading = styled.h3`
  margin-top: 30px;
  width: 100%;
  color: ${props => props.theme.darkText};

  ${props =>
    props.noMargin &&
    css`
      margin: 0 0 10px 0;
    `};
`
export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.darkText};
`

export const StyledAnchor = styled.a`
  text-decoration: none;
  color: ${props => props.theme.darkText};
`

export const StyledP = styled.p`
  font-family: 'RelativeBook';
  font-size: 16px;
  color: ${props => props.theme.darkText};
  text-align: left;
  margin: 0;
  width: 100%;
  padding-bottom: 10px;
  line-height: 1.5;
  ${props =>
    props.moreMargin &&
    css`
      margin-top: 10px;
    `};
  ${props =>
    props.evenMoreMargin &&
    css`
      margin-top: 20px;
    `};
  ${props =>
    props.noPadding &&
    css`
      padding: 0;
    `};
  ${props =>
    props.smaller &&
    css`
      font-size: 14px;
    `};

  ${props =>
    props.isCentered &&
    css`
      text-align: center;
    `};
  ${props =>
    props.isPadded &&
    css`
      padding: 0 40px;
    `};
  ${props =>
    props.morePadding &&
    css`
      padding: 0 0 30px 0;
    `};
`
export const Divider = styled.hr`
  height: 4px;
  background-repeat-y: no-repeat;
  border: none;
  background-image: url('${BorderSvg}');
`
export const Flex = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 44px;

  ${media.tablet`
    display: flex;
  `};

  ${props =>
    props.noMargin &&
    css`
      margin: 0;
    `};
`
export const Placeholder = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  border: 1px solid ${props => props.theme.secondary}
  border-radius: ${props => props.theme.borderRadius};

  animation-duration: 2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: rgba(0, 0, 0, 0.1);
  background: linear-gradient(to right, rgba(0, 0, 0, 0.05) 8%, rgba(0, 0, 0, 0.1) 18%, rgba(0, 0, 0, 0.05) 33%);

  @keyframes placeHolderShimmer{
    0%{
        background-position: -468px 0
    }
    100%{
        background-position: 468px 0
    }
}
`



// WEBPACK FOOTER //
// ./src/theme/globalStyle.js